import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { map, size } from 'lodash'
import { ConversationFlow } from '@scoir/messaging'

import ConversationInput from 'components/ConversationInput'

import './index.scss'

export default class Conversation extends React.Component {
  static propTypes = {
    conversation: PropTypes.array.isRequired,
    participants: PropTypes.array.isRequired,
    discussionOwnerId: PropTypes.string.isRequired,
    onMessageSent: PropTypes.func.isRequired,
  }
  static defaultProps = {
    conversation: [],
    participants: [],
  }
  render() {
    const participantIds = map(this.props.participants, 'ParticipantId')
    return (
      <div className="conversation-comp">
        {size(this.props.conversation) > 0 && (
          <Fragment>
            <div className="conversation-flow-wrapper">
              <ConversationFlow
                ownerId={this.props.discussionOwnerId}
                participants={this.props.participants}
                conversation={this.props.conversation}
              />
            </div>
            <div className="conversation-input-wrapper">
              <ConversationInput
                onMessageSentSuccess={() => this.props.onMessageSent()}
                participantIds={participantIds}
              />
            </div>
          </Fragment>
        )}
        {size(this.props.conversation) === 0 && (
          <div className="empty-wrapper">
            <div className="empty-message">
              No Conversation Here
              <br />
              <small>Find a high school on the map and start talking!</small>
            </div>
          </div>
        )}
      </div>
    )
  }
}
